export const settingStyles = theme => ({
 weekdayswrapper: {
  display: "flex",
  justifyContent: "space-around",
  padding: "10px",
  width: '100%'
 }
})